import React from 'react'
import classNames from 'classnames'
import { Icon, Text, Col } from '@evertel/web/ui'

interface SpacerWidgetProps {
    border?: boolean
    height?: number|string
    scope?: string
    /** Layout classes (e.g. `p-4 col-sm-12`) computed by the parent Row */
    className?: string
}

const SpacerWidget: React.FC<SpacerWidgetProps> = ({
    border,
    height = 30,
    scope,
    className
}) => {

    if (typeof height === 'string') {
        height = (isNaN(parseInt(height, 10))) ? 30 : parseInt(height, 10)
    }

    return (
        <Col
            align="center"
            valign="center"
            className={classNames('spacer', className)}
            // we have a minHeight on rows in the schemaBuilder so if height is less it looks funky
            height={(scope === 'schemaBuilder' && height < 85) ? 85 : height}>
            {(border) && <hr/>}
            {(scope === 'schemaBuilder' && !border) &&
                <div>
                    <Icon
                        name="arrows-up-down"
                        className="me-2"
                    />
                    <Text>
                        Spacer ({height})
                    </Text>
                </div>
            }
        </Col>
    )
}

export {
    SpacerWidget
}
